export default {
    scrollToBottom: () => {
        setTimeout(
            () =>
                window.scrollTo({
                    left: 0,
                    top: window.document.body.scrollHeight,
                    behavior: "smooth",
                }),
            100
        )
    }
}